module.exports = __webpack_public_path__ + "static/media/texture (24).2da72447.jpg";